import classNames from 'classnames';
import { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';

const Root = styled(Horizontal).attrs({ center: true })`
  width: var(--quadruple-unit);
  height: var(--quadruple-unit);
  border-radius: var(--half-unit);
  background-color: var(--c-nd-100);

  & > svg {
    width: var(--intermediate-unit);
    height: var(--intermediate-unit);
    object-fit: contain;
  }
  &.isClaimed > svg {
    opacity: 0.5;
  }
`;

type Props = { isClaimed?: boolean };
export const RewardPreviewWrapper = ({
  isClaimed,
  children,
}: PropsWithChildren<Props>) => {
  return <Root className={classNames({ isClaimed })}>{children}</Root>;
};
